<template>
  <div id="app" class="custom_container">
    <div v-if="showMainHeader">
      <Timer 
        @StopTime="timerStop"
        :timing="getTime(getLiveScheduleObject[0].liveStartTimeMilis)"
        v-if="getLiveScheduleObject.length > 0"
        style="display:none"
      />
      <Timer
        @StopTime="timeUp"
        :timing="getLiveTime(getLiveScheduleObject[0].liveEndTimeMilis)"
        v-if="getLiveScheduleObject.length > 0"
        style="display:none"
      />
      <MainHeader @AiCheck="AiShow" :dataLiveShow="isLiveShow" />
      <NavBar :dataLiveShow="isLiveShow" />
    </div>
    <DetailHeader
      :detail_header="detail_header_text"
      v-if="showDetailHeader"
      :dataLiveShow="isLiveShow"
    />
    <BackHeader :detail_back_header="detail_back_header_text" v-if="showBackHeader" />
    <router-view :key="$route.fullPath" :dataLiveShow="isLiveShow" />
    <Toaster />
    <AI v-if="showAI" @closeAiPage="closeAiPage" />
    <Footer v-if="showFooter" :dataLiveShow="isLiveShow" />
  </div>
</template>

<script>
import Timer from "./components/Common/TimeCount";
import "./assets/css/header-style.scss";
import "./assets/css/artificial-style.scss";
import AI from "./views/AI";
import Toaster from "./components/Common/Toaster";
import MainHeader from "./components/Headers/MainHeader";
import NavBar from "./components/Headers/NavBar";
import constant from "./utils/constant";
import Footer from "./components/Common/Footer";
import DetailHeader from "./components/Headers/DetailHeader";
import BackHeader from "./components/Headers/BackHeader";
import Vue from "vue";
import VueCookie from "vue-cookie";
Vue.use(VueCookie);
var myScrollFunc = function() {
  var y = window.scrollY;
  if (document.getElementById("isFixedHeader")) {
    if (y >= 40) {
      document.getElementById("isFixedHeader").classList.add("is_Sticky");
    } else {
      document.getElementById("isFixedHeader").classList.remove("is_Sticky");
    }
  }
};
export default {
  components: {
    Toaster,
    AI,
    NavBar,
    MainHeader,
    Footer,
    DetailHeader,
    BackHeader,
    Timer
  },
  data() {
    return {
      showHeader: true,
      showAI: false,
      showMainHeader: true,
      showDetailHeader: false,
      showBackHeader: false,
      showFooter: false,
      detail_back_header_text: "",
      isLiveShow: false,
      getLiveScheduleObject: {}
    };
  },
  watch: {
    $route(to, from) {
      if (
        to &&
        to.name &&
        (constant.ShowHeaderComponents.includes(to.name) ||
          constant.ShowHeaderComponents.includes(
            this.$router.currentRoute.name
          ))
      ) {
        this.showMainHeader = true;
        this.showFooter = true;
      } else {
        this.showMainHeader = false;
      }
      if (
        to &&
        to.name &&
        (constant.ShowFooterComponents.includes(to.name) ||
          constant.ShowFooterComponents.includes(
            this.$router.currentRoute.name
          ))
      ) {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }
      if (
        to &&
        to.name &&
        (constant.ShowDetailHeaderComponents.includes(to.name) ||
          constant.ShowDetailHeaderComponents.includes(
            this.$router.currentRoute.name
          ))
      ) {
        this.detail_header_text = this.$router.currentRoute.name;
        this.showDetailHeader = true;
        this.showFooter = true;
      } else {
        this.showDetailHeader = false;
      }
      if (
        to &&
        to.name &&
        (constant.hideBackHeaderComponents.includes(to.name) ||
          constant.hideBackHeaderComponents.includes(
            this.$router.currentRoute.name
          ))
      ) {
        this.showBackHeader = false;
      } else {
        this.detail_back_header_text = this.$router.currentRoute.name;
        this.showBackHeader = true;
        this.showFooter = false;
      }
      if (this.$route.name == "VideoDetailsPage") {
        this.showFooter = false;
      }
    }
  },
  async created() {
    try {
      setTimeout(() => {
        window.addEventListener("beforeinstallprompt", e => {
          // Prevent Chrome 67 and earlier from automatically showing the prompt
          e.preventDefault();
          // Stash the event so it can be triggered later.
          if (e) {
            console.log("==created====event===", e);
            window.Cstmbeforeinstallprompt = e;
          }
        });
      }, 1000);
    } catch (err) {
      console.log("===err==", err);
    }
    const [, , dukaanId] = window.location.pathname.split("/");
    if (dukaanId) {
      try {
        const data = await this.$store
          .dispatch({
            type: "getDukaanCategory",
            payload: dukaanId
          })
          .then(data => {
            let {
              scope,
              scopeCategories,
              scopeSellers,
              businessName
            } = data.data;
            this.DukaanbusinessName = businessName;
            if (scopeCategories.length && scopeSellers.length) {
              window.sessionStorage.setItem(
                "scopeCategories",
                scopeCategories.join(",")
              );
              window.sessionStorage.setItem(
                "scopeSellers",
                scopeSellers.join(",")
              );
              if (["CATEGORIES", "SELLER_CATEGORIES"].includes(scope)) {
                this.$router
                  .push(
                    `product-by-category?type=${scope}&categoryid=${scopeCategories[0]}`
                  )
                  .catch(err => {});
              }
            }
          });
      } catch (e) {
        window.location.href = `http://www.mall91.com/`;
      }
    }
  },
  methods: {
    timerStop(obj) {
      if (obj.timerShow == false) {
        this.isLiveShow = true;
        this.getLiveTime();
      }
    },
    timeUp(obj) {
      if (obj.timerShow == false) {
        this.isLiveShow = false;
        this.getLiveShow()
      }
    },
    getTime(value) {      
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    getLiveShow() {
      this.$store
        .dispatch({ type: "getLiveSale" })
        .then(data => {
          if (data.data.liveScheduleDTOs.length) {
            this.getLiveScheduleObject = data.data.liveScheduleDTOs;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    AiShow(value) {
      this.showAI = value;
    },
    closeAiPage(value) {
      this.showAI = value;
    },
    changeLocale(locale) {
      if (["kn", "ml"].includes(this.$cookie.get("lang"))) {
        document.querySelector("body").classList.add("activeKannada");
      }
      if (["ta"].includes(this.$cookie.get("lang"))) {
        document.querySelector("body").classList.add("activeTamil");
      }
      this.$i18n.locale = this.$cookie.get("lang") || "hi";
    }
  },
  mounted() {
    this.getLiveShow();
    // setInterval(() => {
    //   this.getLiveShow();
    // }, 10000);
    window.addEventListener("scroll", myScrollFunc);
    this.changeLocale();
    if (
      constant.ShowHeaderComponents.includes(this.$router.currentRoute.name)
    ) {
      this.showMainHeader = true;
      this.showFooter = true;
    } else {
      this.showMainHeader = false;
    }
    if (
      constant.ShowDetailHeaderComponents.includes(
        this.$router.currentRoute.name
      )
    ) {
      this.showDetailHeader = true;
      this.showFooter = true;
    } else {
      this.showDetailHeader = false;
    }
    if (
      constant.hideBackHeaderComponents.includes(this.$router.currentRoute.name)
    ) {
      this.showBackHeader = false;
    } else {
      this.showBackHeader = true;
      this.showFooter = false;
    }
    if (
      constant.ShowFooterComponents.includes(this.$router.currentRoute.name)
    ) {
      this.showFooter = true;
    } else {
      this.showFooter = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", myScrollFunc);
  }
};
</script>